import { TGuideItem } from '@r1-frontend/ui-react/components/Guide/GuideItem';
import { House } from '@r1-frontend/ui-react/components/svg/building';
import { CloseBox } from '@r1-frontend/ui-react/components/svg/delivery';
import { Game, MovixHelper } from '@r1-frontend/ui-react/components/svg/devices';
import { Location } from '@r1-frontend/ui-react/components/svg/location';
import { CalendarSecond } from '@r1-frontend/ui-react/components/svg/time';
import { ProfileCircle } from '@r1-frontend/ui-react/components/svg/users';
import { VideoPlay } from '@r1-frontend/ui-react/components/svg/video';

import { ESteps } from '~/src/features/full-buy/types';

type TGuideSteps = Exclude<TGuideItem, 'info'> & {
    value: ESteps,
    info?: string,
}

export const guideSteps: TGuideSteps[] = [
    {
        value: ESteps.address,
        title: 'Проверка адреса',
        description: 'Убедитесь, что в&nbsp;вашем доме есть техническая возможность подключить тариф.',
        Icon: Location,
        isActive: false,
    },
    {
        value: ESteps.equipments,
        title: 'Выбор роутера',
        description: 'Выберите один, если хотите получить от&nbsp;своего тарифа максимум скорости и&nbsp;управлять настройками Wi-Fi через приложение.  ',
        Icon: Game,
        isActive: false,
    },
    {
        value: ESteps.equipmentsCottage,
        title: 'Выбор оборудования',
        description: 'Без него услуги не будут работать, и мы не сможем вам их подключить. Оборудование нужно, чтобы преобразовать оптический ' +
            'сигнал в электрический и передать его по кабелю Ethernet.',
        Icon: House,
        isActive: false,
    },
    {
        value: ESteps.tariffInfo,
        title: 'Выбор подписок',
        description: 'Подписки уже входят в&nbsp;цену тарифа, каждый месяц их&nbsp;можно менять.',
        Icon: VideoPlay,
        isActive: false,
    },
    {
        value: ESteps.contacts,
        title: 'Ввод данных',
        description: 'Укажите свои ФИО и&nbsp;номер телефона, чтобы мы&nbsp;смогли оформить вашу ' +
            'заявку на&nbsp;подключение. Договор оформляем только на&nbsp;лицо старше 18&nbsp;лет.',
        Icon: ProfileCircle,
        isActive: false,
        info: ` 
            <p>Дома должен быть владелец&nbsp;&mdash; тот, на&nbsp;чьё имя оформлен договор. Или его представитель старше 18&nbsp;лет.</p>
            <p style='margin-top: 24px; color: #393C41'>У&nbsp;представителя должна быть доверенность, которую можно написать от&nbsp;руки.</p>
            <p style='margin-top: 24px; color: #393C41'>
                <b>Что обязательно нужно указать в&nbsp;доверенности:</b>
            </p>
            <ul style='color: #393C41; list-style: none;'>
                <li>- ФИО клиента и его представителя</li>
                <li>- паспортные данные владельца и его адрес</li>
                <li>- дату подписания доверенности</li>
                <li>- подтверждение, что клиент передает представителю право представлять его перед третьими лицами</li>
            </ul>
            <p style='margin-top: 24px; color: #393C41'>Также понадобится паспорт представителя и&nbsp;копия паспорта того, на&nbsp;чьё имя будет оформлен договор.</p>
        `,
    },
    {
        value: ESteps.timeSlots,
        title: 'Выбор даты подключения',
        description: 'Выберите день и&nbsp;время, когда инженер приедет, привезёт оборудование, всё установит и&nbsp;настроит.',
        Icon: CalendarSecond,
        isActive: false,
        info: `
            <p style='color: #393C41'>На все работы инженеру понадобится около 60 минут.</p>
            <p style='margin-top: 24px; color: #393C41'>
                <b>Как подготовиться в визиту инженера:</b>
            </p>
            <ul style='color: #393C41; list-style: none;'>
                <li>- Держите под рукой свой паспорт или доверенность на&nbsp;того, кто будет встречать инженера вместо вас.</li>
                <li>- Вспомните логин и&nbsp;пароль от&nbsp;Госуслуг, чтобы быстро ввести их&nbsp;и&nbsp;заключить онлайн-договор.</li>
                <li>- Убедитесь, что на&nbsp;вашей карте хватает денег для оплаты услуг.</li>
                <li>- Выберите и&nbsp;подготовьте место для роутера или ТВ-приставки.</li>
            </ul>
        `,
    },
    {
        value: ESteps.equipmentsTv,
        title: 'Выбор ТВ приставки',
        description: 'Добавьте&nbsp;её, чтобы смотреть ТВ-каналы и&nbsp;подписки из&nbsp;своего тарифа. Если у&nbsp;вас Smart&nbsp;TV, приставку можно не&nbsp;брать.',
        Icon: MovixHelper,
        isActive: false,
    },
    {
        value: ESteps.final,
        title: 'Отслеживание заявки',
        description: 'После оплаты получите смс с&nbsp;ссылкой на&nbsp;свой личный кабинет. ' +
            'Там вы&nbsp;сможете следить за&nbsp;статусом своей заявки, изменить её&nbsp;или отменить.',
        Icon: CloseBox,
        isActive: false,
    },
    {
        value: ESteps.subscriptions,
        title: 'Выбор подписок',
        description: 'Подписки уже входят в&nbsp;цену тарифа, каждый месяц их&nbsp;можно менять.',
        Icon: VideoPlay,
        isActive: false,
    },
];
